export const mergeArraysByIndex = (arrays: unknown[][]) => {
    return arrays[0]
        .map((_, i) => {
            return arrays.map((list) => list[i]);
        })
        .flat();
};
